import * as access_agent_builder from './access-agent-builder';
import * as access_llm from './access-llm';
import * as agent_output_parser from './agent-output-parser';
import * as ai_agent from './ai-agent';
import * as ai_batch from './ai-batch';
import * as anthropic from './anthropic';
import * as azure_openai from './azure-openai';
import * as chat_memory_manager from './chat-memory-manager';
import * as kb_search from './kb-search';
import * as kb_upload from './kb-upload';
import * as langchain_chat_memory from './langchain-chat-memory';
import * as langchain_document_loader from './langchain-document-loader';
import * as langchain_embeddings from './langchain-embeddings';
import * as langchain_prompt_template from './langchain-prompt-template';
import * as langchain_text_splitter from './langchain-text-splitter';
import * as langchain_vector_store from './langchain-vector-store';
import * as llm from './llm';
import * as openai from './openai';
import * as simple_memory from './simple-memory';
import * as text_analysis from './text-analysis';

export const ai_nodesNodes = {
  'access-agent-builder': access_agent_builder,
  'access-llm': access_llm,
  'agentOutputParser': agent_output_parser,
  'ai-agent': ai_agent,
  'ai-batch': ai_batch,
  'anthropic': anthropic,
  'azure-openai': azure_openai,
  'chat-memory-manager': chat_memory_manager,
  'kbSearch': kb_search,
  'kbUpload': kb_upload,
  'langchain-chat-memory': langchain_chat_memory,
  'langchain-document-loader': langchain_document_loader,
  'langchain-embeddings': langchain_embeddings,
  'langchain-prompt-template': langchain_prompt_template,
  'langchain-text-splitter': langchain_text_splitter,
  'langchain-vector-store': langchain_vector_store,
  'llm': llm,
  'openai': openai,
  'simpleMemory': simple_memory,
  'text-analysis': text_analysis,
};
